import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=9ae2e0f0&"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=9ae2e0f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports